import React, { useState } from "react";
import Header from "../Components/Sales/Header";

import SalesOverview from "../Components/Sales/SalesOverview";
import ViewComponent from "../Components/Sales/ViewComponent";

const Sales = ({ userRole }) => {
  const [openViewAction, setOpenViewAction] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const [subtab, setSubtab] = useState("distributor");
  const handleViewAction = (data) => {
    console.log("Selected Product:", data.records);
    setSelectedData(data.records);
    setOpenViewAction(true);
  };

  return (
    <div>
      {!openViewAction && (
        <>
          <Header subtab={subtab} />
          <SalesOverview
            handleViewAction={handleViewAction}
            setSubtab={setSubtab}
            userRole={userRole}
          />
        </>
      )}
      {openViewAction && (
        <>
          <ViewComponent
            handleBack={() => setOpenViewAction(false)}
            selectedData={selectedData}
          />
        </>
      )}
    </div>
  );
};

export default Sales;
